import Header from 'components/Header';
import { Box, useTheme, Tabs, Tab } from '@mui/material';
import React, { useState } from 'react';
import { colorTheme } from '../../theme';
import FundDetails from './FundDetails';
import TransactionDetails from './Transaction';
import { type ITabPanelProps } from 'types';
// import MMUnitSaleDetail from './MMUnitSale';
import { fundDetailsTabDetails } from 'constants/constantText';
import Transactions from 'pages/employeesDetails/transactions';

function TabPanel(props: ITabPanelProps): JSX.Element {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3, height: '75vh' }}>{children}</Box>}
    </div>
  );
}

const FundManagement = (): JSX.Element => {
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);

  /* Tab Menu */
  const [value, setValue] = useState(0);
  const handleChange = (
    event: React.SyntheticEvent,
    newValue: number,
  ): void => {
    setValue(newValue);
  };

  return (
    <Box>
      <Header title="Fund Management" />

      {/* Seporator */}
      <Box py={2} />

      {/* GRID & CHARTS */}
      <Box
        sx={{
          maxWidth: {
            xs: 320,
            sm: 480,
            md: '100%',
          },
          borderRadius: 3,
          px: 2,
          boxShadow: 2,
          bgcolor: 'background.paper',
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          indicatorColor="secondary"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: colors.greenAccent[600],
            },
          }}
          sx={{
            '& .MuiTab-root.Mui-selected': {
              color: colors.greenAccent[500],
            },
          }}
        >
          <Tab label={fundDetailsTabDetails.fundDetails} />
          <Tab label={fundDetailsTabDetails.tradesHistory} />
          <Tab label={fundDetailsTabDetails.mmUnitSalesHistory} />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <FundDetails />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <TransactionDetails />
      </TabPanel>
      <TabPanel value={value} index={2}>
        {/* <MMUnitSaleDetail /> */}
        <Transactions />
      </TabPanel>
    </Box>
  );
};

export default FundManagement;
